<div class="row" style="width: 160px;">
  <div class="col"><app-select-field [placeholder]="'מ-'" [widthSize]="75" [range]="true" (outValue)="setValue('from',$event)"  [filterBase]="filterBaseFrom" [direction]="'from'"></app-select-field></div>
  <div class="col"><app-select-field [placeholder]="'עד'" [widthSize]="75" [range]="true" (outValue)="setValue('to',$event)" [hideTitle]="true"  [filterBase]="filterBaseTo" [direction]="'to'"></app-select-field></div>
</div>


